export default "__VITE_ASSET__1090d7b8__"